(function () {
    "use strict";

    angular
        .module("app")
        .component("shippingLabel", { // shipping-label
            templateUrl: "src/app/shippingLabel/shippingLabel.html",
            controller: controller
        });

    function controller($routeParams, session, ordersService) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.orderId = $routeParams.orderId;
        $ctrl.shippingLabelBytes = "";

        $ctrl.$onInit = () => {
            return ordersService.getShippingLabel($ctrl.orderId).then(result => {
                $ctrl.shippingLabelBytes = `data:image/gif;base64,${result.data.Bytes}`;
            });
        };
    }
    controller.$inject = ["$routeParams", "sessionService", "ordersService"];

})()